import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	getUserSuccess,
	setUserTeamFailure,
	setUserTeamSuccess,
} from 'redux/user/reducer'
import { IUser, IUpdateUserTeam } from './types'

export function* setUserTeamSaga({
	payload,
}: PayloadAction<IUpdateUserTeam>) {
	try {
		const {
			data,
		}: {
			data: { user: IUser }
			message: string
		} = yield call(apiMiddleware, {
			url: app_config.services.updateUserTeam,
			method: 'POST',
			data: payload,
		})

		yield put(getUserSuccess(data.user))

		yield put(setUserTeamSuccess())
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(setUserTeamFailure())
	}
}
